import { apiDelete, apiGet, apiPatch, apiPost } from '../../../shared/api-client/index.js';
import {
  entityDetailKey,
  entityListKey,
  type EntityListKey,
} from '../../../shared/api/entityQueryKeys.js';

export interface CompanyListItem {
  id: string;
  name: string;
  industry?: string | null;
  createdAt: string;
  updatedAt: string;
  contactsCount?: number;
  dealsCount?: number;
  tasksCount?: number;
}

export interface CompanyDetail {
  id: string;
  name: string;
  domain?: string | null;
  industry?: string | null;
  website?: string | null;
  phone?: string | null;
  description?: string | null;
  createdAt: string;
  updatedAt: string;
  contactsCount: number;
}

export function getCompaniesQueryKey(workspaceId: string): EntityListKey {
  return entityListKey('companies', workspaceId);
}

export function getCompanyDetailQueryKey(
  workspaceId: string,
  companyId: string,
): readonly string[] {
  return entityDetailKey('companies', workspaceId, companyId);
}

export async function listCompanies(): Promise<CompanyListItem[]> {
  return apiGet<CompanyListItem[]>('/companies');
}

export async function getCompanyById(companyId: string): Promise<CompanyDetail> {
  return apiGet<CompanyDetail>(`/companies/${companyId}`);
}

export interface CompanyInput {
  name: string;
  domain?: string;
  industry?: string;
  website?: string;
  phone?: string;
  description?: string;
  expectedUpdatedAt?: string;
}

export async function createCompany(input: CompanyInput): Promise<CompanyDetail> {
  return apiPost<CompanyDetail, CompanyInput>('/companies', input);
}

export async function updateCompany(
  id: string,
  input: Partial<CompanyInput>,
): Promise<CompanyDetail> {
  return apiPatch<CompanyDetail, Partial<CompanyInput>>(`/companies/${id}`, input);
}

export async function deleteCompany(id: string): Promise<void> {
  await apiDelete<void>(`/companies/${id}`);
}
